﻿﻿﻿<div class="container-tab-lists dialog.classname">
    <h2>{{title}}</h2>

    <div class="inner-tcontainer-tab">
        <div class="tab-body">
            <exceptionlog-list [list]="list"></exceptionlog-list>
        </div>
    </div>
</div>
